import $ from 'jquery'
import { viewModalEvent } from 'application/ga_view_modal_event'

SOPHIA.overlayBox = function(content, optionsObj, focusElement) {
  var options = optionsObj || {};

  var defaults = {
    baseTpl :
      '<div class="fancybox-container" role="dialog" tabindex="-1">' +
        '<div class="fancybox-bg"></div>' +
        '<div class="fancybox-inner">' +
          '<div class="fancybox-toolbar">' +
            '{{BUTTONS}}' +
          '</div>' +
          '<div class="fancybox-stage"></div>' +
        '</div>' +
      '</div>',
    padding: 0,
    touch : false,
    animationEffect: "fade",
    animationDuration: 1250,
    btnTpl : {
      smallBtn: '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"></button>'
    },
    beforeShow: function() {
      if (!options.doNotFocus) {

        if (!$('.rating_histogram_inner').is(':visible')) {
          $('a:visible, input:visible, textarea, select', $('.fancybox-inner')).eq(0).trigger('focus');
        }

        if ($('#adopt_cancel').length > 0 && $('#choicesList li a:visible').length == 0) {
          $('#adopt_cancel').trigger('focus');
        }
      }

      $('a.close-popup').on('focus', function(e) {
        e.preventDefault();
        $.fancybox.close();
      });
    },
    afterShow: function() {
      if (focusElement != 'undefined' && typeof focusElement == 'object') {
        if (focusElement != 'undefined' && !$(focusElement).hasClass('stars'))
        $('a:visible, input:visible, textarea, select, button', $('.fancybox-inner')).eq(0).trigger('focus');
      }
      if (options && typeof(options['addCompleteFunc']) == 'function') {
        options['addCompleteFunc']();
      }

      $(window).on('beforeunload', function(){
        SOPHIA.closeOverlayBox();
      });
    },
    beforeClose: function() {
      if (focusElement != 'undefined' && typeof focusElement == 'object') {
        focusElement.trigger('focus');
      }
      if (options && typeof(options['addCleanupFunc']) == 'function') {
        options['addCleanupFunc']();
      }
    }
  };

  if (typeof content === 'object' && !content.type) {
    content = { type: 'inline', src: content };
  }

  $.fancybox.open(content, $.extend({}, defaults, options));
  return false;

};

SOPHIA.closeOverlayBox = function() {
  $.fancybox.close();
};

// modal GA start
$(document).on('afterLoad.fb', function(e, instance, slide) {
  $('.white, .ok, .lime', slide.$content).off('.gaClick').on('click.gaClick', (e) => {
    SOPHIA.clickModalCloseForGA($(e.target))
  });
});

$(document).on('afterShow.fb', function(e, instance, slide) {
  const isSpinnerPopup = slide.$content.is('.fancybox-loading'),
    isFlexiblePage = $('body.flexible-layout:not(.touchstone-grading-page)')

  if (!isSpinnerPopup && isFlexiblePage ) {
    const gaDataViewModal = { module_name: 'automated' }
    viewModalEvent(gaDataViewModal)
  }

  if ($('form[data-form-overlay]', slide.$content).length) {
    SOPHIA.formGA($('form[data-form-overlay]'), 'form_view');
  }

  $('[data-fancybox-close]', slide.$content).off('.gaClick').on('click.gaClick', (e) => {
    SOPHIA.clickModalCloseForGA($(e.target))
  });
});

$(document).on('afterClose.fb', function( e, instance, slide ) {
  SOPHIA.clickModalCloseForGA(false, slide.$content)
});

SOPHIA.signInPopup = function(header_message, body_message, options, focusElement) {
  var $form = $('#you_must_be_signed').clone();

  $('#header_message', $form).html(header_message);
  $('#body_message', $form).html(body_message);

  SOPHIA.overlayBox($form, {
    afterLoad: function() {
      $('.must-be-create-account').on('keydown', function(e) {
        if (e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
          e.preventDefault();
          SOPHIA.closeOverlayBox();
        }
      });
    }
  }, focusElement);

  return $form;
};

SOPHIA.confirm = function (message, callback, focusElement, options) {
  if ('undefined' == typeof options) options = {};
  options = $.extend({}, {
    onCancel:      function(){},
    onOk:          callback,
    onClose:       function(){},
    cancelCaption: 'Cancel',
    okCaption:     'OK',
    relaunchConfirm: false,
    popupTitle: ''
  }, options);

  var defaults = {
    btnTpl: {
      smallBtn: 'false'
    },
    clickSlide: false,
    keyboard : false,
    afterLoad: function(e) {
      bindConfirmForm(this, e, options);
    },
    beforeClose: function() {
      unbindConfirmForm();

      if (focusElement != 'undefined' && typeof focusElement == 'object') {
        focusElement.focus();
      }
    }
  };

  if (options.popupTitle != '') {
    options.popupTitle = '<h3>' + options.popupTitle + '</h3>';
  }

  var html = [
    '<div class="basicConfirm relaunchConfirm medium">',
      '<p>', message, '</p>',
      '<div class="buttons">',
        '<input class="cancel w-button white" type="button" value="', options.cancelCaption, '" />',
        '<input class="ok w-button purple" type="button" value="', options.okCaption, '" />',
      '</div>',
    '</div>'
  ].join('');

  var okLink,
      okLinkHref = typeof options.okHref == 'undefined' ? 'javascript:void(0)' : options.okHref;

  if (options.relaunchConfirm === true) {
    okLink = '<a href="' + okLinkHref +'" class="ok w-button purple">'+options.okCaption+'</a>';
  } else if (options.flexibleHtml === true) {
    okLink = '<input class="ok w-button purple" type="button" value="'+ options.okCaption+ '" />';
  }

  var flexibleHtml = [
    '<div class="basicConfirm flexible-popup medium">',
      options.popupTitle,
      '<p>', message, '</p>',
      '<div class="buttons">',
        okLink,
        '<input class="cancel w-button white" type="button" value="', options.cancelCaption, '" />',
      '</div>',
    '</div>'
  ].join('');

  if (options.relaunchConfirm === true || options.flexibleHtml === true) {
    SOPHIA.overlayBox(flexibleHtml, $.extend([], defaults, options), focusElement);
  } else {
    SOPHIA.overlayBox(html, $.extend([], defaults, options), focusElement);
  }
};

SOPHIA.fancyboxShowActivity = function() {
  SOPHIA.overlayBox('<div class="fancybox-loading"></div>', {
    autoFocus: false,
    backFocus: false,
    btnTpl : {
      smallBtn: 'false'
    },
    clickSlide: false,
    keyboard : false,
    baseClass : 'spinner-bg'
  });
}

SOPHIA.fancyboxHideActivity = function() {
  SOPHIA.closeOverlayBox();
}

/* PRIVATE */

function bindConfirmForm(element, event, callbacks) {
  var $confirm = $('.basicConfirm, .relaunchConfirm');
  $('.ok', $confirm).on('click', function(){
    callbacks.onOk();
    SOPHIA.closeOverlayBox();
  });

  $('.cancel', $confirm).on('click', function(){
    callbacks.onCancel();
    SOPHIA.closeOverlayBox();
  });

  // to close popup after pressing SHIFT+TAB on the first element of overlay
  $('a:first-child, input:first-child', $confirm).on('keydown', function(e) {
    if (e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
      e.preventDefault();
      $('.close-popup').trigger('focus');
    }
  });
}

function unbindConfirmForm() {
  var $confirm = $('.basicConfirm');
  $('input[type=button]', $confirm).off();
}

